import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { MMMAdminService } from 'src/app/admin-mmm/admin-mmm.reports.service';
import { ETLJob } from '../change-report.model';
import { MatButtonModule } from '@angular/material/button';
import { NgFor, NgStyle, NgIf, AsyncPipe, DatePipe } from '@angular/common';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';


@Component({
    selector: 'app-selection',
    templateUrl: './selection.component.html',
    styleUrls: ['./selection.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatOptionModule, NgFor, NgStyle, NgIf, MatButtonModule, AsyncPipe, DatePipe]
})
export class SelectionComponent implements OnInit {

  etlJobList$ : Observable<ETLJob[]>;
  formGroup: UntypedFormGroup;
  reviewedFormGroup: UntypedFormGroup;
  
  @Output() jobIdSelected = new EventEmitter<number>();
  constructor(private formBuilder: UntypedFormBuilder, private adminService : MMMAdminService) { }

  ngOnInit() {
    this.etlJobList$ = this.adminService.getJobDetails();
    this.createForm();
  }

  //create initial form
  createForm() {
    this.formGroup = this.formBuilder.group({
      'jobId': [null, [Validators.required]]
    });
  }

  //get jobid of form.
  get jobId() {
    return this.formGroup.get('jobId') as UntypedFormControl
  }

  //Submission methods
  onSubmit() {
    this.jobIdSelected.emit(this.jobId.value);
  }
}
